import type {IssueParticipantsQuery} from '@github-ui/server-persisted-queries/types/IssueParticipants'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

type ParticipantsConnection = NonNullable<
  NonNullable<NonNullable<IssueParticipantsQuery['repository']>['issue']>['participants']
>

export type ParticipantNode = NonNullable<NonNullable<ParticipantsConnection['nodes']>[number]>

export function participantsQueryKey(owner: string, repo: string, number: number) {
  return ['issue-viewer', 'participants', {owner, repo, number}] as const
}

export async function fetchParticipants(
  owner: string,
  repo: string,
  number: number,
  signal?: AbortSignal,
): Promise<ParticipantNode[]> {
  const response = await verifiedFetchJSON(`/${owner}/${repo}/issues/${number}/participants`, {signal})
  if (!response.ok) {
    throw new Error(`Participants fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {data?: IssueParticipantsQuery; errors?: unknown[]}
  if (json.errors?.length || !json.data) {
    throw new Error('Participants query returned errors')
  }

  return (json.data.repository?.issue?.participants?.nodes || []).flatMap(node => (node ? node : []))
}
